var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-4"},[_c('h3',{staticClass:"mb-2 text-center font-medium text-gray-800 dark:text-white",domProps:{"textContent":_vm._s(_vm.$t('home.customerSays'))}}),_c('div',{staticClass:"elfsight-app-2a1306c4-2226-4e0a-a360-c3ccecab4299"})])
}
var staticRenderFns = []

export { render, staticRenderFns }